import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Bearer token is a fallback for browsers where the httpOnly cookie cannot
// travel (e.g. WebView/iframe scenarios). The primary auth path is the
// httpOnly cookie set by the backend — the token here is a defense-in-depth
// fallback, not the source of truth.
client.interceptors.request.use((config) => {
    const token = localStorage.getItem("feetrate_token");
    if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (d == null) return err?.message || "Something went wrong";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) {
        return d
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    }
    if (d && typeof d.msg === "string") return d.msg;
    return String(d);
}

export function fileUrl(path) {
    if (!path) return "";
    return `${API}/files/${path}`;
}

export default client;
